module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0